export default "__VITE_ASSET__BzKJ6RPr__"